const styles = {
  filterRow: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
  },

  filterLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },

  rightControls: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },

  fabButton: {
    width: 48,
    height: 48,
    minWidth: 48,
    minHeight: 48,
    borderRadius: '50%',
    backgroundColor: '#5236AB',
    color: '#fff',
    border: '1px solid #5236AB',
    padding: 0,
    '&:hover': {
      backgroundColor: '#E0E0E0',
    },
  },
};

export default styles;
